import { Record as record } from 'immutable';
import _ from 'lodash';

import config from '../../../../config';
import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve } from '../../../../helpers/LinkMapper';
import { KeyGoTapStatus, KeyGoTapGenerationCause, KeyGoTapTypes } from '../../../../constants/AppConstants';

const fieldSchema = {
    "tapId": [resolve.with(Number)],
    "locationCode": [resolve.with(String)],
    "locationName": [resolve.with(String)],
    "operatorName": [resolve.with(String)],
    "timestamp": [resolve.with(trainTime)],
    "type": [resolve.with(String)],
    "generationCause": [resolve.with(String)],
    "status": [resolve.with(String)]
};

class Tap extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Tap, json, getResolvers(fieldSchema));
    }

    hasLocationCode () {
        return !_.isNil(this.locationCode);
    }

    hasLocationName () {
        return !_.isNil(this.locationName);
    }

    hasTimestamp () {
        return !_.isNil(this.timestamp);
    }

    refreshTimestamp (min, max) {
        const timestamp = this.timestamp || min;
        return this.set('timestamp', trainTime.max(min, trainTime.min(max, timestamp)));
    }

    getTapPairTimestamp () {
        const maxDurationBetweenTaps = trainTime.duration(config.get('keyGoMaxDurationBetweenTaps'));
        if (this.isEntry()) {
            return this.timestamp.clone().add(maxDurationBetweenTaps);
        } else {
            return this.timestamp.clone().subtract(maxDurationBetweenTaps);
        }
    }

    isEntry () {
        return this.type === KeyGoTapTypes.ENTRY;
    }

    isExit () {
        return this.type === KeyGoTapTypes.EXIT;
    }

    isGenerated () {
        return this.status === KeyGoTapStatus.GENERATED;
    }

    isCausedBy (event) {
        return event ? this.generationCause === event : false;
    }

    hasError () {
        return this.isCausedBy(KeyGoTapGenerationCause.UNKNOWN) || this.isCausedBy(KeyGoTapGenerationCause.AUTOFILL);
    }

    isUnknown () {
        return this.hasError() && this.isCausedBy(KeyGoTapGenerationCause.UNKNOWN);
    }

    isAutofill () {
        return this.hasError() && this.isCausedBy(KeyGoTapGenerationCause.AUTOFILL);
    }

    isComplete () {
        return !this.hasError() || this.isAutofill();
    }
}

export default Tap;



// WEBPACK FOOTER //
// ./src/records/customer/keygo/journeyHistory/Tap.js